<template>
  <v-container>
    <v-card width="400" class="mx-auto mt-5">
      <v-card-title>
        <h4 class="display-1 font-weight-bold mb-3">
          Iniciar Sesión
        </h4>
      </v-card-title>

      <v-card-text @keyup.enter="validate">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            label="Usuario"
            v-model="username"
            id="user"
            name="user"
            type="text"
            :rules="[rules.required]"
          >
            <v-icon color="#757575" slot="prepend">mdi-account</v-icon>
          </v-text-field>

          <v-text-field
            label="Contraseña"
            v-model="password"
            id="password"
            name="password"
            :type="showpass ? 'text' : 'password'"
            :rules="[rules.required]"
            prepend-icon="mdi-lock"
            :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showpass = !showpass"
          >
          </v-text-field>
          <div align="center">
             <v-btn
                class="mb-2"
                color="success"
                :loading="loading"
                :disabled="!valid"
                @click="validate"
             ><b>Ingresar</b></v-btn>
             <br>
             <v-btn
                class="mb-2"
                color="primary"
                @click="dialog = true"
             ><b>Registrar</b></v-btn>
             <br>
            <v-btn
                class="mb-2"
                text
                color="red darken-4"
                @click="dialogRecupera = true"
            >¿OLVIDASTE TU CONTRASEÑA?</v-btn>
          </div>
        </v-form>

        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-form ref="formRegistro" v-model="validRegistro" lazy-validation>
            <v-card>
              <v-card-title style="background-color: dimgrey;">
                <img src="@/assets/logo_nuevo.png" style="width:50px;height:51px">
                <span class="headline ml-7" style="color: white;">
                  <b>BUZÓN ELECTRÓNICO - REGISTRAR CUENTA</b>
                </span>
              </v-card-title>
              <v-card-text>
                <v-row class="mt-2">
                  <v-col cols="12" md="6">
                    <v-card elevation="0">
                      <v-card-text>
                        <v-row class="mt-n5">
                          <v-col cols="12">
                            <v-text-field
                              v-model="registro.nombre"
                              label="Nombre(s)"
                              :rules="[rules.required]"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="mt-n5">
                          <v-col cols="12">
                            <v-text-field
                              v-model="registro.primer_apellido"
                              label="Primer Apellido"
                              :rules="[rules.required]"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="mt-n5">
                          <v-col cols="12">
                            <v-text-field
                              v-model="registro.segundo_apellido"
                              label="Segundo Apellido"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="mt-n5">
                          <v-col cols="12">
                            <v-text-field
                              v-model="registro.curp"
                              label="CURP"
                              :rules="[rules.required, rules.curp]"
                              maxlength="18"
                              counter="18"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-card elevation="0">
                      <v-card-text>
                        <v-row class="mt-n5">
                          <v-col cols="12">
                            <v-text-field
                              v-model="registro.email"
                              label="Email Personal"
                              :rules="[rules.required, rules.email]"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="mt-n5">
                          <v-col cols="12">
                            <v-text-field
                              v-model="registro.password"
                              label="Contraseña"
                              :type="show1 ? 'text' : 'password'"
                              :rules="[rules.required, rules.password]"
                              minlength="8"
                              counter=""
                              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                              @click:append="show1 = !show1"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="mt-n5">
                          <v-col cols="12">
                            <v-text-field
                              v-model="registro.password_confirmation"
                              label="Confirmar Contraseña"
                              :type="show2 ? 'text' : 'password'"
                              :rules="[rules.required,
                                        (this.registro.password === this.registro.password_confirmation) || 'Las contraseñas no coinciden'
                                      ]"
                              minlength="8"
                              counter=""
                              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                              @click:append="show2 = !show2"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <!-- <v-card-title class="mb-n3 justify-center">
                  Términos y condiciones:
                </v-card-title> -->
                <v-container accesskey="" class="overflow-y-auto">
                  <v-row style="height: 190px">
                    <div style="border:ridge">
                      <v-checkbox
                        class="mt-0 mr-5 ml-3 text-justify"
                        v-model="checkbox1"
                        :rules="[rules.checkbox]"
                        required
                        label="Manifiesto expresamente mi conformidad de que las notificaciones realizadas
                              electrónicamente surtirán efectos a las 12:00 horas del día hábil siguiente al envió
                              señalado en la constancia correspondiente, independientemente si el destinatario abrió
                              o no abrió el correo electrónico que señaló para recibir notificaciones; salvo que las
                              normas procesales señalen otro término para que las notificaciones surtan sus efectos
                              legales; siguiendo los lineamientos establecidos  en el “acuerdo del Pleno del
                              Supremo Tribunal de Justicia del Estado de Jalisco que regula el registro de cédula
                              profesional de abogados y licenciados en derecho, y la notificaciones electrónicas en
                              los juicios de competencia del Supremo Tribunal de Justicia”."
                      ></v-checkbox>
                      <v-checkbox
                        class="mt-n1 mr-5 ml-3 text-justify"
                        v-model="checkbox2"
                        :rules="[rules.checkbox]"
                        required
                        label="Manifiesto expresamente mi conformidad para que los actos derivados de esta plataforma
                              se efectúen desde el inicio hasta la conclusión del procedimiento a través de medios de
                              comunicación electrónica de conformidad al artículo 3 fracción I y 10 del Acuerdo General
                              8/2021 emitido por el Supremo Tribunal de Justicia del Estado de Jalisco."
                      ></v-checkbox>
                    </div>
                  </v-row>
                </v-container>
                <v-col align="center">
                  <vue-recaptcha
                    ref="recaptcha"
                    @verify="onVerify"
                    @expired="onExpired"
                    :sitekey="sitekey"
                    :loadRecaptchaScript="true">
                  </vue-recaptcha>
                </v-col>
                <v-card-actions class="mt-1 justify-center">
                    <v-btn color="grey darken-3" dark @click.native="closeDialog()">Cancelar</v-btn>
                    <v-btn color="success" @click.native="registrar()" :disabled="!validRegistro" :loading="loading" class="white--text">Registrar</v-btn>
                </v-card-actions>
              </v-card-text>
            </v-card>
          </v-form>
        </v-dialog>

        <v-dialog v-model="dialogRecupera" persistent width="500">
          <v-form ref="formRecupera" v-model="validRegistro" lazy-validation>
            <v-card>
              <v-card-title style="background-color: dimgrey;">
                <span class="headline ml-7" style="color: white;">
                  <b>RECUPERACIÓN DE CONTRASEÑA</b>
                </span>
              </v-card-title>
              <v-card-text>
                <v-row class="mt-2 ml-6 mr-6">
                  <v-col cols="12">
                    <v-text-field
                      v-model="emailRecupera"
                      label="Email Personal Registrado en el Sistema"
                      :rules="[rules.required, rules.email]"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col align="center">
                    <vue-recaptcha
                      ref="recaptcha"
                      @verify="onVerify"
                      @expired="onExpired"
                      :sitekey="sitekey"
                      :loadRecaptchaScript="true">
                    </vue-recaptcha>
                  </v-col>
                </v-row>
                <v-card-actions class="mt-1 justify-center">
                    <v-btn color="grey darken-3" dark @click.native="closeDialogRecupera()">Cancelar</v-btn>
                    <v-btn color="success" @click.native="recuperarContraseña()" :disabled="!validRegistro" :loading="loading" class="white--text">Continuar</v-btn>
                </v-card-actions>
              </v-card-text>
            </v-card>
          </v-form>
        </v-dialog>

      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
export default {
  //name: "LoginLayout",
  components: { VueRecaptcha },
  props: {
    source: String
  },
  data() {
    return {
      sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      checkbox1: false,
      checkbox2: false,
      dialog: false,
      dialogRecupera: false,
      emailRecupera: '',
      registro:{
        nombre:'',
        primer_apellido:'',
        segundo_apellido:'',
        curp:'',
        email:'',
        password:'',
        password_confirmation:'',
      },
      defaultItem:{
        nombre:'',
        primer_apellido:'',
        segundo_apellido:'',
        curp:'',
        email:'',
        password:'',
        password_confirmation:'',
      },
      show1: false,
      show2: false,
      drawer: null,
      valid: true,
      validRegistro: true,
      username: "",
      password: "",
      showpass: false,
      rules: {
        required:v => !!v.trim() || 'Campo requerido',
        checkbox:v => !!v || 'Campo requerido',
        curp: v => v.length == 18 || 'Requiere 18 caracteres',
        password: v => v.length >= 8 || 'Requiere mínimo 8 caracteres',
        email: v =>  {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(v) || 'E-mail invalido.'
        },
      },
      loading: false
    };
  },
  watch: {
    'registro.curp': function(val) {
      this.registro.curp = val.toUpperCase()
    }
  },
  methods: {
    onVerify: function (response) {
      this.verifytoken = response
    },
    onExpired: function () {
      console.log('Expired')
      this.verifytoken = ''
      this.$refs.recaptcha.reset();
    },
    registrar() {
      if (this.$refs.formRegistro.validate()) {
        if (!this.verifytoken) {
          this.$swal({ icon: 'warning', title: 'Seleccione la casilla No soy un robot' })
          return false;
        }
        this.loading = true
        this.registro.verifytoken = this.verifytoken
        this.$store.dispatch("SAVE_USERS", { url:"/user/abogado", data:this.registro } ).then(response => {
          // this.closeDialog('registro');
          this.$swal({
            icon: 'success',
            title: 'Éxito!!!' + '</br>' +' Favor de revisar el correo proporcionado (' + response.data.data.user.email +') para activar la cuenta.',
            confirmButtonText: "Aceptar"
          })
          setTimeout(function () {
            location.reload()
          }, 2000);
        })
        .catch(error => {
          console.log(error);
          if (error.response.data.errors.email[0] == 'The email has already been taken.') {
            this.$swal({
              icon: 'error',
              title: 'El correo ' + this.registro.email + ' ya fue registrado en el sistema.',
              confirmButtonText: "Aceptar"
            })
          }
          this.loading = false
        });
      }
    },
    recuperarContraseña(){
      if (this.$refs.formRecupera.validate()) {
        if (!this.verifytoken) {
          this.$swal({ icon: 'warning', title: 'Seleccione la casilla No soy un robot' })
          return false;
        }
        this.loading = true
        this.$store.dispatch("RESET_PASSWORD", { url:"/user/send-recovery-pass",
        data:{
          user_email: this.emailRecupera,
          verifytoken: this.verifytoken
        }
        }).then(response => {
          // console.log(response)
          if (response.data.status == 'ok') {
            this.$swal({
              icon: 'success',
              title: 'El email de cambiar contraseña ha sido enviado. Favor de revisar su correo electrónico.',
              confirmButtonText: "Aceptar"
            })
          }
          setTimeout(function () {
            this.closeDialogRecupera()
            this.loading = false
          }.bind(this), 2000);
        }).catch(error => {
          console.log(error);
          this.$swal({
            icon: 'error',
            title: 'Error al recuperar la contraseña, verifique los datos',
            confirmButtonText: "Aceptar"
          })
          this.loading = false
        });
      }
    },
    closeDialogRecupera(){
      this.verifytoken = ''
      this.$refs.recaptcha.reset();
      this.dialogRecupera = false,
      this.emailRecupera='',
      this.$refs.formRecupera.resetValidation()
    },
    closeDialog(text) {
      this.checkbox1 = false
      this.checkbox2 = false
      this.loading = false
      this.registro = Object.assign({}, this.defaultItem)
      this.$refs.formRegistro.resetValidation()
      this.verifytoken = ''
      this.$refs.recaptcha.reset();
      if (text == 'registro') {
        setTimeout(function () {
          this.dialog = false
        }.bind(this), 2000);
      }else {
        this.dialog = false
      }
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let username = this.username;
        let password = this.password;
        this.$store
          .dispatch("LOGIN", {
            email: username,
            password: password
          })
          .then((response) => {
            this.$swal({
              title: "Bienvenido !!!",
              icon: "success",
              timer: 1000
            });
            if (response.data.user.roles[0].id <= 3 || response.data.user.roles[0].id == 5 || response.data.user.roles[0].id >= 7) {
              window.location = "/panel"
            }else {
              window.location = "/escritos/panel"
            }
          })
          .catch(error => {
            this.loading = false;
            this.$swal({
              title: "Error",
              text: error.response.data.message,
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          });
      }
    }
  }
};
</script>
